export enum PayorTypeEnum {
  Episodic60 = 1,
  Episodic30 = 2,
  PerVisitWeekly = 3,
  PerVisitMonthly = 4
}

export const PayorTypeOptions = [
{ id: 1, label: 'Episodic - 60-day Period' },
{ id: 2, label: 'Episodic - 30-day Period' },
{ id: 3, label: 'Per Visit - Weekly' },
{ id: 4, label: 'Per Visit - Monthly' }
];
